export default __webpack_public_path__ + "static/media/IP.8f405b96.svg";